var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowOutwardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24271 5.59017C5.24271 6.0485 5.61771 6.4235 6.07604 6.4235H12.401L5.00104 13.8235C4.67604 14.1485 4.67604 14.6735 5.00104 14.9985C5.32604 15.3235 5.85104 15.3235 6.17604 14.9985L13.576 7.5985V13.9235C13.576 14.3818 13.951 14.7568 14.4094 14.7568C14.8677 14.7568 15.2427 14.3818 15.2427 13.9235V5.59017C15.2427 5.13184 14.8677 4.75684 14.4094 4.75684H6.07604C5.61771 4.75684 5.24271 5.13184 5.24271 5.59017Z",
    fill: "#A1A1AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowOutwardIcon);
export default __webpack_public_path__ + "static/media/ArrowOutwardIcon.01b1aade251bfaa68e39c60c5f8947c6.svg";
export { ForwardRef as ReactComponent };